export class BdPermissionsUsersAdminStore {
  constructor(private readonly _baseUrl: string) {}

  public users(): string {
    return `${this._base()}/users/`;
  }

  public usersAll(): string {
    return `${this._base()}/users/all`;
  }

  public userById(userId: string): string {
    return `${this._base()}/users/${userId}`;
  }

  public userEnable(userId: string): string {
    return `${this._base()}/users/${userId}/enable`;
  }

  public userDisable(userId: string): string {
    return `${this._base()}/users/${userId}/disable`;
  }

  /** No trailing slash — matches `PUT /users/{userId}/login-email` in the spec. */
  public userLoginEmail(userId: string): string {
    return `${this._base()}/users/${userId}/login-email`;
  }

  public userDeletionCheck(userId: string): string {
    return `${this._base()}/users/${userId}/deletion-check`;
  }

  public userContentPurge(userId: string): string {
    return `${this._base()}/users/${userId}/content-purge`;
  }

  public userMembershipCompanies(userId: string): string {
    return `${this._base()}/users/${userId}/companies`;
  }

  public userMembershipGroups(userId: string): string {
    return `${this._base()}/groups/memberships/${userId}/`;
  }

  private _base(): string {
    return this._baseUrl;
  }
}
